export default "/_next/static/images/7ef190d5b4980f43dc5d8897267298be.jpg";